'use client';

import { atom } from 'jotai';

export const currentProductIdAtom = atom<string | undefined>(undefined);

export const resetCurrentProductIdAtom = atom(null, (_get, set) => {
  set(currentProductIdAtom, undefined);
});
